import React, { useState, useEffect } from 'react'
import ContactFormModalContent from './ContactFormModalContent'
import ContactConfirmationModalContent from './ContactConfirmationModalContent'
import { OtherFormProps } from './types'
import CustomerService from "@apps/Shared/Services/Customer/Customer.service";
import { ContactCustomerPostBody } from "@apps/Shared/Services/Customer/interfaces";
import { StatusCode } from "@apps/Shared/Services/Response.types";
import Modal from "@sharedComponents/Modal";
import { ModalSize } from "@sharedComponents/Modal/types";

const OtherForm = (props: OtherFormProps) => {
    const [showContactFormModal, setShowContactFormModal] = useState<boolean>(
        false
    )
    const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(
        false
    )
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [requestErrors, setRequestErrors] = useState<any>({})

    const cmsContentContactForm = {
        infoText: props.cmsContent?.step1,
        phone: props.cmsContent?.step2,
        email: props.cmsContent?.step3,
    }
    const cmsContentConfirmModal = props.cmsContent?.step4

    const resetRequestErrors = () => {
        setRequestErrors({})
    }

    const hideContactFormModal = () => {
        setShowContactFormModal(false)
        resetRequestErrors()
        props.onHide()
    }

    const hideConfirmationModal = () => {
        setShowConfirmationModal(false)
        resetRequestErrors()
        props.onHide()
    }

    const onSubmit = (formValues: ContactCustomerPostBody) => {
        setSubmitting(true)
        CustomerService.ContactCustomer(formValues)
            .then(result => {
                if (result.status === StatusCode.OK) {
                    setShowContactFormModal(false)
                    setShowConfirmationModal(true)
                    setRequestErrors({ ...requestErrors, submit: [] })
                } else {
                    const errorMessages = result.data.message
                    console.log(errorMessages)
                    setRequestErrors({
                        ...requestErrors,
                        submit: errorMessages,
                    })
                }
                setSubmitting(false)
            })
            .catch((error: any) => {
                console.log(error)
                setSubmitting(false)
            })
    }

    useEffect(() => {
        setShowContactFormModal(props.open)
    }, [props.open])

    return (
        <>
            <Modal
                open={showContactFormModal}
                handleClose={hideContactFormModal}
            >
                <ContactFormModalContent
                    onSubmit={onSubmit}
                    formType={props.formType}
                    open={showContactFormModal}
                    cmsContent={cmsContentContactForm}
                    submitting={submitting}
                    requestErrors={requestErrors.submit || []}
                />
            </Modal>
            <Modal
                open={showConfirmationModal}
                handleClose={hideConfirmationModal}
                size={ModalSize.ExtraSmall}
            >
                <ContactConfirmationModalContent
                    cmsContent={cmsContentConfirmModal}
                    onClose={hideConfirmationModal}
                />
            </Modal>
        </>
    )
}

export default OtherForm